$(() => {
  const pluginName = 'registrationQuestionsPlugin';
  const dataKey = `plugin_${pluginName}`;
  let settings = {};
  let $pluginContainer = null;
  let plugin;

  const Plugin = function registrationQuestionsPlugin(element, options) {
    plugin = this;
    this.element = element;
    this.settings = {
      registrationPlugin: null,
      registrationUrl: null,
      i18n: null,
      eventCountry: null,
      registrantIndex: 1,
      registrantPersonalInformation: null,
      callbacks: {
        getSelectedCountry: () => {},
        getProvidedFor: () => {},
      },
    };
    settings = $.extend(this.settings, options);

    // Set the container for the plugin
    $pluginContainer = element;
    $pluginContainer.questionsPlugin({
      registrationPlugin: settings.registrationPlugin,
      i18n: settings.i18n,
      eventCountry: settings.eventCountry,
      registrantIndex: settings.registrantIndex,
      registrantPersonalInformation: settings.registrantPersonalInformation,
      callbacks: settings.callbacks,
    });
  };

  /**
   * Clear the plugin's contents
   */
  Plugin.prototype.clear = () => {
    $pluginContainer.empty();
  };

  /**
   * Toggle the visibility of this component
   *
   * @param isVisible
   */
  Plugin.prototype.toggleVisibility = (isVisible) => {
    $pluginContainer.toggleClass('hidden', !isVisible);
  };

  Plugin.prototype.toggleOptInQuestions = (show) => {
    $pluginContainer.questionsPlugin('toggleOptInQuestions', show);
  };

  Plugin.prototype.toggleGeographicallyLimitedQuestions = (readyToCheckCountry, country) => {
    $pluginContainer.questionsPlugin('toggleGeographicallyLimitedQuestions', readyToCheckCountry, country);
  };

  /**
   * Initialize the functional components of the content
   */
  Plugin.prototype.initializeContent = () => {
    $pluginContainer.questionsPlugin('initializeContent');
  };

  /**
   * Display the plugin's contents
   * @param content
   */
  Plugin.prototype.displayContent = (content = null) => {
    // Load in the content first
    if (content) {
      $pluginContainer.html(content);
    }

    // Initialize things
    plugin.initializeContent();
    $pluginContainer.trigger(`${pluginName}.contentDisplayed`);
  };

  /**
   * Get the country from the registrant personal information or the callback
   * @returns {string|null}
   */
  Plugin.prototype.getCountry = () => settings.callbacks.getSelectedCountry()
    ?? settings.registrantPersonalInformation?.address?.countryCode
    ?? '';

  /**
   * Get the provided for value (self vs someone else) from the registrant personal information
   * or the callback
   * @returns {string|null}
   */
  Plugin.prototype.getProvidedFor = () => settings.callbacks.getProvidedFor()
    ?? settings.registrantPersonalInformation?.provided_for
    ?? 'someone-else';

  /**
   * Serialize the plugin's contents
   * @returns {*}
   */
  Plugin.prototype.serialize = () => {
    const data = $pluginContainer.serializeArray();

    const formattedData = data.map((field) => {
      const $element = $pluginContainer.find(`[name="${field.name}"]`);

      // Update the value to the international phone number
      if ($element.is('[data-format-phone-number]')) {
        field.value = window.intlTelInput.getInstance($element[0]).getNumber();
      }

      return field;
    });

    const country = plugin.getCountry();

    if (country) {
      formattedData.push({
        name: 'questions[country]',
        value: country,
      });
    }

    const providedFor = plugin.getProvidedFor();

    if (providedFor) {
      formattedData.push({
        name: 'questions[provided_for]',
        value: providedFor,
      });
    }
    return $.param(formattedData);
  };

  /**
   * Plugin wrapper, preventing against multiple instantiations and
   * return plugin instance.
   */
  $.fn[pluginName] = function pluginWrapper(options) {
    let thisPlugin = this.data(dataKey);

    // has plugin instantiated ?
    if (thisPlugin instanceof Plugin) {
      // if have options arguments, call plugin.init() again
      if (typeof options !== 'undefined') {
        thisPlugin.init(options);
      }
    } else {
      thisPlugin = new Plugin(this, options);
      this.data(dataKey, thisPlugin);
    }

    return thisPlugin;
  };
});
